import { render, staticRenderFns } from "./ArtigoFormulario.vue?vue&type=template&id=525713db"
import script from "./ArtigoFormulario.vue?vue&type=script&lang=js"
export * from "./ArtigoFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports